module.exports = __webpack_public_path__ + "img/617.13d08c53.png";